/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsLastVisitedProgramBoardIdResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { advancedRoadmapsSummaryDataResource } from '@jira/router-resources__advanced-roadmaps-summary/src/advancedRoadmapsSummaryDataResource.tsx';
import { summaryPagePreferencesResource } from '@jira/router-resources__advanced-roadmaps-summary/src/summaryPagePreferencesResource.tsx';
import { PORTFOLIO_PLAN_VIEW } from '@jira/platform__observability-capabilities/src/constants.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayout } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import {
	getNavigationResources,
	getNavigationSidebarPlanResources,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanSummaryRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanSummaryRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanSummaryPage, { LazyPlanSummary } from './ui/plan-summary/index-old.tsx';
import { planSummaryPageEntryPoint } from './ui/plan-summary/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';

export const softwarePlanSummaryRouteEntry: Route = createEntry(softwarePlanSummaryRoute, () => ({
	group: 'software',
	entryPoint: () => planSummaryPageEntryPoint,
	ufoName: 'software-advanced-roadmaps-summary',
	// eslint-disable-next-line no-restricted-syntax
	component: PlanSummaryPage,
	layout: composeLayouts(globalLayout, planLayout),

	resources: [
		...getNavigationResources(),
		...getNavigationSidebarPlanResources(),
		advancedRoadmapsPlanPageInitialChecksResource,
		advancedRoadmapsSummaryDataResource,
		summaryPagePreferencesResource,
		advancedRoadmapsLastVisitedProgramBoardIdResource,
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	navigation: {
		menuId: MenuIdPlans,
	},

	forPaint: [LazyAtlassianNavigation, LazyPlanSummary],
	meta: {
		capability: expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)
			? PORTFOLIO_PLAN_VIEW
			: undefined,
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
